// src/components/ApplicationsSection.jsx
import React from 'react';

const APPLICATIONS = [
  { icon: 'fa-mug-saucer', title: 'Food & Beverages', desc: 'Concentrated ingredient solutions for flavour-forward food and beverage systems.' },
  { icon: 'fa-mortar-pestle', title: 'Sauces & Marinades', desc: 'Bring concentrated spice character and consistent flavour to sauces and dressings.' },
  { icon: 'fa-drumstick-bite', title: 'Meat & Poultry', desc: 'Enhance flavour systems across marinades, coatings and seasoning blends.' },
  { icon: 'fa-cheese', title: 'Dairy', desc: 'Support flavour development across selected dairy applications.' },
  { icon: 'fa-paw', title: 'Pet Food', desc: 'Ingredient solutions designed for selected pet food and animal nutrition applications.' },
  { icon: 'fa-capsules', title: 'Nutraceuticals', desc: 'Concentrated botanical ingredients for suitable formulation requirements.' },
  { icon: 'fa-cookie', title: 'Bakery', desc: 'Add authentic spice character to bakery and prepared-food formulations.' },
  { icon: 'fa-bacon', title: 'Seasonings & Snacks', desc: 'Deliver bold spice profiles with controlled ingredient addition.' },
];

const ApplicationsSection = () => {
  return (
    <section className="page-content grey">
      <div className="container">
        <div className="section-header text-center">
          <h3>One Source, Many Possibilities</h3>
        </div>
        <p style={{ textAlign: 'center', maxWidth: 720, margin: '0 auto 30px' }}>
          Cornerstone ingredients are designed to integrate into diverse formulation environments, helping
          manufacturers achieve authentic flavour, colour, aroma and functional ingredient performance.
        </p>
        <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
          {APPLICATIONS.map((a, i) => (
            <div className="col-6 col-md-3" key={i} style={{ marginBottom: 26, textAlign: 'center', padding: '0 12px' }}>
              <div
                style={{
                  width: 70, height: 70, borderRadius: '50%', margin: '0 auto 12px',
                  border: '1px solid var(--brand-gold)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}
              >
                <i className={`fas ${a.icon}`} style={{ fontSize: 24, color: 'var(--brand-gold-light)' }}></i>
              </div>
              <div style={{ color: 'var(--brand-cream)', fontWeight: 700, fontSize: 14, marginBottom: 6 }}>{a.title}</div>
              <div style={{ color: 'var(--brand-cream-dim)', fontSize: 12.5 }}>{a.desc}</div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: 10, color: 'var(--brand-gold)', fontFamily: 'var(--brand-heading-font)', letterSpacing: 1 }}>
          FLAVOUR &nbsp;|&nbsp; COLOUR &nbsp;|&nbsp; AROMA &nbsp;|&nbsp; FUNCTIONALITY &nbsp;|&nbsp; CONSISTENCY
        </div>
      </div>
    </section>
  );
};

export default ApplicationsSection;
